import getSymbolFromCurrency from "currency-symbol-map";
import React from "react";
import { useDispatch } from "react-redux";

import {
  IgDivider,
  IgSwitch,
  IgTextfieldHeaderWTooltip,
  IgTypography,
} from "@intelligems/ig-theme";
import {
  AnyProgressBarWidget,
  DiscountMessageBoxWidget,
  DiscountQuantityWidget,
  WidgetTypeType,
} from "@intelligems/ig-types";
import { FormControlLabel, Grid, InputAdornment } from "@mui/material";

import { useConfiguration } from "../../../api/configurations/use-configuration";
import {
  setSitewideWidgetEnabled,
  setSitewideWidgetThreshold,
} from "../../../store/slices/widgets";

interface GlobalSettingsProps {
  widgetType: WidgetTypeType;
  widget:
    | DiscountQuantityWidget
    | AnyProgressBarWidget
    | DiscountMessageBoxWidget;
}

export const GlobalSettings = ({ widget, widgetType }: GlobalSettingsProps) => {
  const storeCurrencyConfig = useConfiguration<{
    code: string;
    locale: string;
  }>("shop_currency");
  const dispatch = useDispatch();

  if (widgetType === "shippingProgressBar") {
    return (
      <Grid item>
        <Grid item sx={{ marginTop: "10px", marginBottom: "10px" }}>
          <IgTypography sx={{ fontWeight: 600, fontSize: "16px" }}>
            Global Settings
          </IgTypography>
        </Grid>
        <Grid item sx={{ marginLeft: "10px", marginBottom: "10px" }}>
          <FormControlLabel
            control={
              <IgSwitch
                checked={widget.enabledSitewide}
                onChange={() => {
                  dispatch(setSitewideWidgetEnabled());
                }}
              />
            }
            label={
              widget.enabledSitewide ? "Widget Enabled" : "Widget Disabled"
            }
          />
        </Grid>
        {widget.enabledSitewide ? (
          <Grid item>
            <IgTextfieldHeaderWTooltip
              title={"Default Threshold"}
              tooltip={
                "The default free shipping threshold to show if no live experiences are found. In other words, you may continue using this component even without live experiences. To hide the component when no live experiences are found, set to 0."
              }
              variant={"outlined"}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    {getSymbolFromCurrency(
                      storeCurrencyConfig!.value!.code || "USD"
                    )}
                  </InputAdornment>
                ),
              }}
              value={
                widget.config.desktop?.variables
                  ? widget.config.desktop?.variables[
                      "defaultShippingThreshold"
                    ] || 0
                  : 0
              }
              onChange={(e) =>
                dispatch(setSitewideWidgetThreshold(Number(e.target.value)))
              }
            />
          </Grid>
        ) : null}
        <Grid item>
          <IgDivider spacing={"m"} />
        </Grid>
      </Grid>
    );
  }

  return null;
};
